/**
 * @typedef API
 * @property {string} [baseUrl] - The inLive API base URL
 * @property {string} [version] - The version of the API
 */

/**
 * @type {API} - The API configuration
 */
const api = {
  baseUrl: 'https://api.inlive.app',
  version: 'v1',
}

export { api }
